export const isKeyOf = (key, obj) => key in obj;
//# sourceMappingURL=is-key-of.js.map